/**
 * Created by Victor Rojo on 31/8/17.
 */
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard }        from "./shared/auth/auth-guard.service";

import { MainComponent }    from './main.component';
import { DashboardComponent }   from "./dashboard/dashboard.component";
import { ProfileComponent } from "./profile/profile.component";
import { CloudUserListComponent } from "./admin/cloudUser-list.component";
import { CloudUserDetailComponent } from "./admin/cloudUser-detail.component";
import {NotificationListComponent} from "./notification/notification-list.component";
import {NotificationDetailComponent} from "./notification/notification-detail.component";
import {IPlaceDashboardMainComponent} from "./IPlaceDashboard/IPlaceDashboardMain.component";
import {ErrorDashboardComponent} from "./IPlaceDashboard/errorDashboard/ErrorDashboard.component";
import {IPlaceDashboardComponent} from "./IPlaceDashboard/iPlaceDashboard/IPlaceDashboard.component";
import {CloudNotificationListComponent} from "./IPlaceDashboard/notification/CloudNotificationList.component";
import {SurveillanceComponent} from "./IPlaceDashboard/surveillance/Surveillance.component";
import {RankingComponent} from "./IPlaceDashboard/ranking/Ranking.component";
import {RecordingsComponent} from "./IPlaceDashboard/recordings/Recordings.component";
import {ReconciliationComponent} from "./IPlaceDashboard/reconciliation/Reconciliation.component";
import {SalesComponent} from "./IPlaceDashboard/sales/Sales.component";
import {StartComponent} from "./IPlaceDashboard/start/Start.component";
import {HistoricComponent} from "./IPlaceDashboard/historic/Historic.component";
import {JournalComponent} from "./IPlaceDashboard/journal/Journal.component";
import {ChartsComponent} from "./IPlaceDashboard/charts/Charts.component";
import {ConfigurationComponent} from "./IPlaceDashboard/configuration/Configuration.component";
import {IPlaceFinderComponent} from "./IPlaceDashboard/iPlace/IPlaceFinder.component";
import {TankDeliveryNoteComponent} from "./IPlaceDashboard/tankDeliveryNote/TankDeliveryNote.component";
import {PetrolStatisticsComponent} from "./IPlaceDashboard/petrol_statistics/PetrolStatistics.component";
import {PetrolDiscountTransactionComponent} from "./IPlaceDashboard/petrolDiscount/PetrolDiscountTransaction.component";
import {PetrolSettlementReportComponent} from "./IPlaceDashboard/petrolDiscount/PetrolSettlementReport.component";
import {EcopricingComponent} from "./IPlaceDashboard/ecopricing/Ecopricing.component";
import {EcosensorComponent} from "./IPlaceDashboard/ecosensor/Ecosensor.component";
import {EcomplianceComponent} from "./IPlaceDashboard/ecompliance/Ecompliance.component";
import {CEIComponent} from "./IPlaceDashboard/cei/CEI.component";
import {TankLevelsComponent} from './IPlaceDashboard/ipetrol/tank-levels/tank-levels.component';
import {TankHistoricComponent} from './IPlaceDashboard/ipetrol/tank-historic/tank-historic.component';
import {TankBooksComponent} from './IPlaceDashboard/ipetrol/tank-books/tank-books.component';
import {LevelsGraphComponent} from './IPlaceDashboard/ipetrol/levels-graph/levels-graph.component';
import {ManualTransactionsComponent} from './IPlaceDashboard/manualTransactions/manualTransactions.component';
import {MonitoredEquipmentListComponent} from './IPlaceDashboard/sergas/monitoredEquipment/monitored-equipment-list/monitored-equipment-list.component';
import {MonitoredEquipmentDetailComponent} from './IPlaceDashboard/sergas/monitoredEquipment/monitored-equipment-detail/monitored-equipment-detail.component';
import {IncidenceListComponent} from "./IPlaceDashboard/sergas/incidence/IncidenceList.component";
import {IncidenceDetailComponent} from "./IPlaceDashboard/sergas/incidence/incidence-detail/incidence-detail.component";
import {GenerateReportComponent} from './IPlaceDashboard/sergas/generate-report/generate-report.component';

const routes: Routes = <Routes>[
  {
    path: '', component: MainComponent, canActivate: [AuthGuard], children: [
    {path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard]},
    {path: 'profile', component: ProfileComponent, canActivate: [AuthGuard]},
    {path: 'users', component: CloudUserListComponent, canActivate: [AuthGuard]},
    {path: 'users/new', component: CloudUserDetailComponent, canActivate: [AuthGuard]},
    {path: 'users/:id', component: CloudUserDetailComponent, canActivate: [AuthGuard]},
    {path: 'notifications', component: NotificationListComponent, canActivate: [AuthGuard]},
    {path: 'notifications/:id', component: NotificationDetailComponent, canActivate: [AuthGuard]},
  ]
  },
  {
    path: 'cloud', component: IPlaceDashboardMainComponent, canActivate: [AuthGuard], children: [
    {path: 'issues', component: ErrorDashboardComponent, canActivate: [AuthGuard], },
    {path: 'iplaces', component: IPlaceFinderComponent, canActivate: [AuthGuard], children: [
      {path: ':iPlaceId/section/:sectionId', component: IPlaceDashboardComponent, canActivate: [AuthGuard]},
    ]},
    {path: 'start', component: StartComponent, canActivate: [AuthGuard]},
    {path: 'notifications', component: CloudNotificationListComponent, canActivate: [AuthGuard]},
    {path: 'tank-deliveries', component: TankDeliveryNoteComponent, canActivate: [AuthGuard]},
    {path: 'fuel-transaction', component: PetrolDiscountTransactionComponent, canActivate: [AuthGuard]},
    {path: 'settlement-report', component: PetrolSettlementReportComponent, canActivate: [AuthGuard]},
    {path: 'statistics', component: PetrolStatisticsComponent, canActivate: [AuthGuard]},
    {path: 'surveillance', component: SurveillanceComponent, canActivate: [AuthGuard]},
    {path: 'ranking', component: RankingComponent, canActivate: [AuthGuard]},
    {path: 'recordings', component: RecordingsComponent, canActivate: [AuthGuard]},
    {path: 'sales', component: SalesComponent, canActivate: [AuthGuard]},
    {path: 'reconciliation', component: ReconciliationComponent, canActivate: [AuthGuard]},
    {path: 'historic', component: HistoricComponent, canActivate: [AuthGuard]},
    {path: 'journal', component: JournalComponent, canActivate: [AuthGuard]},
    {path: 'configuration', component: ConfigurationComponent, canActivate: [AuthGuard]},
    {path: 'charts', component: ChartsComponent, canActivate: [AuthGuard]},
    {path: 'ecopricing', component: EcopricingComponent, canActivate: [AuthGuard]},
    {path: 'ecosensor', component: EcosensorComponent, canActivate: [AuthGuard]},
    {path: 'ecompliance', component: EcomplianceComponent, canActivate: [AuthGuard]},
    {path: 'cei', component: CEIComponent, canActivate: [AuthGuard]},
    {path: 'tank-levels', component: TankLevelsComponent, canActivate: [AuthGuard]},
    {path: 'tank-historic', component: TankHistoricComponent, canActivate: [AuthGuard]},
    {path: 'tank-books', component: TankBooksComponent, canActivate: [AuthGuard]},
    {path: 'levels-graph', component: LevelsGraphComponent, canActivate: [AuthGuard]},
    {path: 'manual-sales', component: ManualTransactionsComponent, anActivate: [AuthGuard]},
    {path: 'iplace/:iPlaceId/section/:sectionId', component: IPlaceDashboardComponent, canActivate: [AuthGuard]},
    {path: 'monitored-equipment', component: MonitoredEquipmentListComponent, canActivate: [AuthGuard]},
    {path: 'monitored-equipment/:sergasDeviceId', component: MonitoredEquipmentDetailComponent, canActivate: [AuthGuard]},
    {path: 'incidences', component: IncidenceListComponent, canActivate: [AuthGuard]},
    {path: 'incidences/:incidenceId', component: IncidenceDetailComponent, canActivate: [AuthGuard]},
    {path: 'generate-report', component: GenerateReportComponent, canActivate: [AuthGuard]}
  ]
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, { useHash: true , onSameUrlNavigation: 'reload'})],
  exports: [ RouterModule ]
})
export class AppRoutingModule{
}
